import type { ReactNode } from "react";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  return <Layout {...props} />;
}
